import { Repeat2 } from 'lucide-react'
import Post from './Post'

interface RepostCardProps {
  reposterName: string
  reposterUsername: string
  post: any
  currentUserId?: string
  isGuest?: boolean
}

export default function RepostCard({
  reposterName,
  reposterUsername,
  post,
  currentUserId,
  isGuest,
}: RepostCardProps) {
  return (
    <div>
      {/* Repost header */}
      <div className="flex items-center gap-2 px-4 pt-2 text-gray-500 text-sm">
        <Repeat2 className="w-4 h-4 ml-6" />
        <span className="font-medium">{reposterName} reposted</span>
      </div>
      {/* Original post */}
      <Post post={post} currentUserId={currentUserId} isGuest={isGuest} />
    </div>
  )
}
